App.SmDatetimeComponent = Em.TextField.extend
  classNames: [ 'sm-datetime' ]
  tagName: 'input'

  date: null
  type: 'datetime-local'
  valueBinding: 'localDate'

  installChangeHandler: (->
    @$().on 'change', =>
      Em.run.next =>
        return if @get('isDestroyed')
        @sendAction('onChange', @$().val())
  ).on('didInsertElement')

  localDate: ( (key, value, previousValue) ->
    if arguments.length > 1
      dateValue =  if Em.isEmpty(value)
        null
      else
        moment(value).toDate()

      @set('date', dateValue)

    moment(@get('date')).format('YYYY-MM-DDTHH:mm')
  ).property('date')